import React, { useState } from "react";
import TimePickerDropDown from "./TimePickerDropDown";
import { ClockIcon } from './HeroIcons';
import { getFormattedTimeSlot24 } from '../../../tools/date.util';

const TimePicker = ({timeSlot, setTimeSlot, trips}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenModal = () => setIsOpen(true);
    const handleCloseModal = () => setIsOpen(false);


    const toggleDropdown = () => {
      if(isOpen){
        handleCloseModal()
      }else{
        handleOpenModal()  
      }
    }
    return (
      <>
        {/* Figma: white bg, 0.911px rgba(110,108,113,0.3) border, ~5px radius,
            37px tall, #6E6C71 text. */}
        <div
          className="flex-1 px-3 flex items-center justify-between"
          style={{
            backgroundColor: '#FFFFFF',
            border: '0.911px solid rgba(110,108,113,0.3)',
            borderRadius: '5px',
            height: '37px',
          }}>
          <div className="font-light inline-block" style={{ color: '#6E6C71', fontSize: '14.57px' }}>{timeSlot ? getFormattedTimeSlot24(timeSlot) : "Time"}</div>
          <ClockIcon
            data-testid={'clock-icon'}
            className="cursor-pointer"
            style={{ color: '#6E6C71' }}
            onClick={toggleDropdown}
          />
        </div>
        {isOpen && (
          <div className="mt-1" style={{ position: 'absolute', top: 'calc(100%-1.5rem)', left: "216px", zIndex: 20 }}>
            <TimePickerDropDown
              handleCloseModal = {handleCloseModal} 
              setTimeSlot = {setTimeSlot}
              timeSlot = {timeSlot}
              trips={trips}
            />
            </div>
        
        )}
    </>
    );
};

export default TimePicker;